<template>
  <span
    v-if="actualCountryCode"
    v-tooltip.right="actualCountryCode"
    :class="['flag', actualCountryCode.toLowerCase()]"
  />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CountryFlag',
  props: {
    countryCode: {
      type: String,
      required: true,
    },
  },
  computed: {
    actualCountryCode() {
      return this.countryCode ? this.countryCode.split(':')[0] : '';
    },
  },
});

</script>
